import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { Bell, Newspaper } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { API } from "@/App";

export const NotificationsBell = () => {
  const [data, setData] = useState({ notifications: [], unread_count: 0 });
  const [open, setOpen] = useState(false);

  const load = async () => {
    try {
      const res = await fetch(`${API}/notifications`, { credentials: "include" });
      if (res.ok) setData(await res.json());
    } catch (e) {}
  };

  useEffect(() => { load(); }, []);

  const handleOpen = async (isOpen) => {
    setOpen(isOpen);
    if (isOpen && data.unread_count > 0) {
      await fetch(`${API}/notifications/read-all`, { method: "POST", credentials: "include" }).catch(() => {});
      setData(d => ({ ...d, unread_count: 0 }));
    }
  };

  return (
    <Popover open={open} onOpenChange={handleOpen}>
      <PopoverTrigger asChild>
        <Button variant="ghost" size="icon" className="relative text-white/60 hover:text-white" data-testid="notifications-bell">
          <Bell className="w-5 h-5" />
          {data.unread_count > 0 && (
            <span className="absolute -top-0.5 -right-0.5 w-4 h-4 rounded-full bg-neon text-black text-[9px] font-bold flex items-center justify-center" data-testid="notifications-badge">{data.unread_count > 9 ? "9+" : data.unread_count}</span>
          )}
        </Button>
      </PopoverTrigger>
      <PopoverContent align="end" className="bg-dark-paper border-white/10 w-80 p-0" data-testid="notifications-panel">
        <div className="p-3 border-b border-white/10 font-semibold text-sm">Notifications</div>
        <div className="max-h-72 overflow-y-auto">
          {data.notifications.length === 0 ? (
            <p className="p-4 text-white/40 text-xs text-center">No notifications yet. We'll alert you when new AIs match your searches.</p>
          ) : data.notifications.map(n => (
            <div key={n.notif_id} className={`p-3 border-b border-white/5 ${!n.read ? "bg-purple-900/10" : ""}`} data-testid={`notification-${n.notif_id}`}>
              <p className="text-xs font-semibold text-purple-300 mb-0.5">{n.title}</p>
              <p className="text-[11px] text-white/50 leading-relaxed">{n.message}</p>
              <div className="flex items-center gap-3 mt-1">
                <Link to="/news" onClick={() => setOpen(false)} className="text-[10px] text-purple-400 hover:underline flex items-center gap-1"><Newspaper className="w-3 h-3" />View in News Feed</Link>
                <span className="text-[10px] text-white/25">{new Date(n.created_at).toLocaleDateString()}</span>
              </div>
            </div>
          ))}
        </div>
      </PopoverContent>
    </Popover>
  );
};

export default NotificationsBell;
